(() => {
  document.addEventListener("contextmenu", function (e) {
    e.preventDefault();
  });

  document.addEventListener("keydown", function (e) {
    if (
      (e.ctrlKey && e.shiftKey && e.key === "I") ||
      e.key === "F12" ||
      e.key === "F11" ||
      e.key === "F10" ||
      e.key === "PrtSc" ||
      e.key === "PrintScreen" ||
      (e.ctrlKey && e.key === "p") ||
      (e.metaKey && e.key === "p")
    ) {
      e.preventDefault();
    }
  });

  document.body.style.userSelect = "none";
  document.querySelectorAll("*").forEach(function (element) {
    element.style.userSelect = "none";
  });

  document.addEventListener("copy", function (e) {
    e.preventDefault();
  });

  document.addEventListener("dragstart", function (e) {
    e.preventDefault();
  });
})();
